export default __webpack_public_path__ + "static/media/t-imfg.f7eab82a.png";